import React, { useState } from 'react';
import Logo from '../../components/Logo';
import { useNavigate } from 'react-router-dom';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';

function ResetPassword() {
  const navigate = useNavigate();

  const [showPass, setShowPass] = useState({
    password: false,
    confirmPassword: false,
  });

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = () => {
    navigate('/code');
  };

  const togglePasswordVisibility = (field) => {
    setShowPass((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  return (
    <div className=''>
      <div className='h-screen w-full bg-white  dark:bg-black grid place-content-center'>
        <div className='h-full w-full p-10 flex space-x-20'>
          <div className=''>
            <div className='mb-20'>
              <Logo />
            </div>
            <div className="">
              <div className="text-[76px] font-sans hidden md:block">
                <h1 className="text-[#2A71E8] text-[70px] font-sans">Lets</h1>
                <h1 className="flex space-x-2 text-[#2A71E8] text-[70px] font-sans">
                  Get<span className="ml-3 text-[#be2117]">Started...</span>
                </h1>
              </div>
            </div>
            <button className="bg-gradient-to-b from-[#BE2117] to-[#09062C] rounded-[20px] p-4 px-11 text-white w-[240px]">
              TRANSLATE
            </button>
          </div>

          <div className='h-full sm:bg-[#f4f4f4] dark:bg-[#33333347]  rounded-[50px] w-80 pb-10'>
            <div className='flex justify-center'>
              <div className='border-2 border-[#5D5FEF] w-14 mt-3'></div>
            </div>
            <div className='flex flex-col items-center px-12 mt-14'>
              <div className='space-y-3'>
                <p className='font-[600]'>Reset Password</p>
                <p className='text-[11px] font-[400]'>Set the new password for your account so you can login and access all the features.</p>
              </div>
            </div>

            <div className='flex flex-col items-center px-12 mt-10 '>
              <div className='space-y-3'>
                <div>
                <p className='font-[400] text-[12px] mb-3'>Password</p>
                <div className='w-full border border-[#D9D9D9] rounded-[25px]  dark:bg-[#33333347] bg-[#D9D9D9] h-[30px] mb-14 flex items-center px-3'>
                  <input
                    type={showPass.password ? "text" : "password"}
                    className='w-full focus:outline-none rounded-[25px] bg-[#D9D9D9]  dark:bg-[#33333347] h-[30px] px-2'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
{showPass.password ? (
                    <AiOutlineEye
                      className="w-6 h-6 cursor-pointer"
                      onClick={() => togglePasswordVisibility('password')}
                    />
                  ) : (
                    <AiOutlineEyeInvisible
                      className="w-6 h-6 cursor-pointer"
                      onClick={() => togglePasswordVisibility('password')}
                    />
                  )}
                </div>
                </div>

                <div>
                <p className='font-[400] text-[12px] mb-3'>Confirm Password</p>
                <div className='w-full border border-[#D9D9D9] rounded-[25px]  dark:bg-[#33333347] bg-[#D9D9D9] h-[30px] mb-14 flex items-center px-3'>
                  <input
                    type={showPass.confirmPassword ? "text" : "password"}
                    className='w-full focus:outline-none rounded-[25px] bg-[#D9D9D9]  dark:bg-[#33333347] h-[30px] px-2'
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
{showPass.confirmPassword ? (
                    <AiOutlineEye
                      className="w-6 h-6 cursor-pointer"
                      onClick={() => togglePasswordVisibility('confirmPassword')}
                    />
                  ) : (
                    <AiOutlineEyeInvisible
                      className="w-6 h-6 cursor-pointer"
                      onClick={() => togglePasswordVisibility('confirmPassword')}
                    />
                  )}
                </div>
                </div>

                <button
                  onClick={handleSubmit}
                  className='w-full border border-[#D9D9D9] rounded-[20px] bg-[#2A71E8] text-white p-1 text-[15px] mt-10'
                >
                  Reset Password
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
